import { QuickSearchService } from "front-end/components/quick-search/quick-search.service";
import { HomeSlickComponent } from "front-end/components/homeslick.component";
import { VideoBoxService } from "front-end/components/video-box/video-box.service";
import { deviceService } from "core";
import { EmergencyMessageService } from "front-end/components/emergency-message/emergency-message.service";
import { pageService } from "front-end/components/page/page.service";
import { NewsFilterService } from "front-end/components/news-filter/news-filter.service";
import { BannersService } from "front-end/components/banners/banners.service";
import { GeoDistanceService } from "front-end/services/geolocation/geo-distance.service";
import { TeamMembersProfilesService } from "front-end/components/team-members-profiles/team-members-profiles.service";
import { CookiebotService } from "front-end/components/cookiebot/cookiebot.service";
import { FormsSectionService } from "front-end/components/sections/forms-section/forms-section.service";
import { MaskedInput } from "front-end/components/umbraco-form/masked-input.component";
import { SitesInfoBannerMediaService } from "./components/sites-info-banner-media/sites-info-banner-media.service";

class Frontend {
    public init(): void {
        deviceService.init();
        pageService.init();

        $.extend($, {
            ina: {
                frontend: {
                    quickSearchService: new QuickSearchService(),
                    emergencyMessageService: new EmergencyMessageService(),
                    homeSlick: HomeSlickComponent,
                    videoBoxService: VideoBoxService,
                    cookiebotService: new CookiebotService(),
                    newsFilterService: new NewsFilterService(),
                    bannersService: new BannersService(),
                    teamMembersProfiles: new TeamMembersProfilesService(),
                    formsSectionService: new FormsSectionService(),
                    geoDistanceService: new GeoDistanceService(),
                    sitesInfoBannerMediaService: new SitesInfoBannerMediaService()
                },
                umbracoForms: {
                    controls: {
                        maskedInput: MaskedInput
                    }
                }
            }
        });
    }
}

export const frontend = new Frontend();
